import getQuoteIdFromUrl from './getQuoteIdFromUrl';

type Window = {
  getQuoteIdUrl: string;
};

const _window = window as unknown as Window;

const getCartFromUrl = (url, requestData) => {
  return new Promise((resolve, reject) => {
    getQuoteIdFromUrl(_window.getQuoteIdUrl)
      .then((quoteId) => {
        fetch(url, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...requestData, quoteid: quoteId }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default getCartFromUrl;
